import * as Sentry from '@sentry/react';

const dsn = process.env.REACT_APP_SENTRY_DSN;
let initialized = false;

const withoutQuery = (url) => (typeof url === 'string' ? url.split(/[?#]/)[0] : url);

// Events never carry request bodies, cookies, headers or query strings.
export const scrubEvent = (event) => {
  if (!event) return event;
  if (event.request) {
    const { url, method } = event.request;
    event.request = { url: withoutQuery(url), method };
  }
  delete event.user;
  return event;
};

// Console breadcrumbs repeat log arguments, so they are dropped. Request
// breadcrumbs keep only the method, status and a URL without its query string.
export const scrubBreadcrumb = (breadcrumb) => {
  if (!breadcrumb) return breadcrumb;
  if (breadcrumb.category === 'console') return null;
  if (breadcrumb.category === 'xhr' || breadcrumb.category === 'fetch') {
    const data = breadcrumb.data || {};
    return { ...breadcrumb, data: { method: data.method, status_code: data.status_code, url: withoutQuery(data.url) } };
  }
  if (breadcrumb.category === 'navigation') {
    const data = breadcrumb.data || {};
    return { ...breadcrumb, data: { from: withoutQuery(data.from), to: withoutQuery(data.to) } };
  }
  return breadcrumb;
};

// No-op unless REACT_APP_SENTRY_DSN is set — safe to call even without a
// Sentry account. Existing server-side error logging (utils/reportError.js)
// keeps working either way; this is additive, not a replacement.
export const initSentry = () => {
  if (!dsn || initialized) return;
  Sentry.init({
    dsn,
    environment: process.env.NODE_ENV,
    tracesSampleRate: 0,
    sendDefaultPii: false,
    beforeSend: scrubEvent,
    beforeBreadcrumb: scrubBreadcrumb
  });
  initialized = true;
};

export const captureError = (error, info) => {
  if (!initialized) return;
  Sentry.captureException(error, {
    contexts: { react: { componentStack: info?.componentStack } }
  });
};
